const l = {
  // heading sizes NOT viewport size
  heading: {
    xxsmall: "1",
    xsmall: "2",
    small: "3",
    medium: "4",
    large: "5",
    xlarge: "6"
  },
  // icon sizes NOT viewport size
  icon: {
    xxsmall: "small",
    // 24px
    xsmall: "small",
    // 24px
    small: "small",
    // 24px
    medium: "medium",
    // 32px
    large: "large",
    // 40px
    xlarge: "large"
    // 40px
  }
};
export {
  l as titleSizeConfig
};
